module.exports = __webpack_public_path__ + "media/images/logo-64b69d17c1bde6d83d4b07a64c175344.svg";